import { useTheme } from '@mui/material/styles';
import { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { type StackedIconProps } from '@constants/scan';

import { ScanResultContext } from '@contexts/index';

import { ScanType } from 'generated/types';

const messages = defineMessages({
  face: {
    id: 'scanHistoryMain.face',
    defaultMessage: 'Face',
  },
  body: {
    id: 'scanHistoryMain.body',
    defaultMessage: 'Body',
  },
  cough: {
    id: 'scanHistoryMain.cough',
    defaultMessage: 'Cough',
  },
  skin: {
    id: 'scanHistoryMain.skin',
    defaultMessage: 'Skin',
  },
});

export function useScanResults() {
  const context = useContext(ScanResultContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useScanResults must be used within a ScanResultProvider`);
  }

  const { state } = context;
  const { scan_type } = state;
  const { formatMessage } = useIntl();
  const {
    palette: { primary, secondary },
  } = useTheme();

  let friendlyType: {
    id: string;
    defaultMessage: string;
  } = messages.face;
  let icons: StackedIconProps[] = [];
  switch (scan_type) {
    case ScanType.respiratory:
      friendlyType = messages.cough;
      icons = [
        {
          name: 'head-side-cough',
          color: primary.main,
        },
      ];
      break;
    case ScanType.skin:
      friendlyType = messages.skin;
      icons = [
        {
          name: 'person-dots-from-line',
          color: primary.main,
        },
      ];
      break;
    case ScanType.body:
      friendlyType = messages.body;
      icons = [
        {
          name: 'expand',
          color: secondary.main,
          size: 'lg',
          transform: { x: -2 },
        },
        {
          name: 'person',
          color: secondary.main,
        },
      ];
      break;
    case ScanType.face:
    default:
      icons = [
        {
          name: 'face-smile',
          color: primary.main,
        },
      ];
      break;
  }

  return {
    ...state,
    friendly_type: formatMessage(friendlyType),
    icons,
  };
}
